

















import VueOptions from '@utils/VueOptions'
import CreativeFields from '@ui/FormBuilder/ResourceFields/CreativeFields.coffee'
import FormField from '@ui/FormBuilder/FormField'

settings =
  name: 'PartnershipForm'

  vue:
    props: ['wizard', 'form']

    components: {
      FormField,
    }

    computed:
      errors: -> {}

      fieldKeys: ->
        [
          'pitch'
          'images'
          'sponsor_set'
          'catex'
        ]

      formFields: ->
        fields = {}
        fields[key] = @creativeFields.fields[key] for key in @fieldKeys
        fields

      contextForCreativeFields: ->
        _requiredFields: ['images']
        options:
          images: @wizard.mediaKits
          sponsor_primary_domains: @wizard.audienceCreativeData.sponsor_set

      creativeFields: ->
        CreativeFields(@contextForCreativeFields)

    methods:
      hiChangeField: (fieldKey, value) ->
        @wizard.saveField fieldKey
        @autoAddBrandPartnersFromCatex value if fieldKey is 'catex'

      autoAddBrandPartnersFromCatex: (catex) ->
        sponsorSet = [...@form.data.sponsor_set]
        for category, obj of catex when !obj.prohibited
          for sponsor in obj.sponsors when !sponsorSet.some((s) => s.domain is sponsor.domain)
            sponsorSet.push sponsor
        @form.data.sponsor_set = sponsorSet
        @wizard.saveField 'sponsor_set'

export default VueOptions.vue settings
